// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_LOGIN = "P\u0159ihl\u00e1\u0161en\u00ed";
